import React, {Component} from 'react';
import styles from './TipCardList.scss';
import classNames from 'classnames/bind';
import TipCard from '../TipCard';

const cx = classNames.bind(styles);

class TipCardList extends Component {
  frameId = null;
  state = {
    cardList: this.props.tipCards
  };

  componentDidMount() {
    this.animate();
  }

  animate = () => {
    this.frameId = window.setInterval(() => {
      const {cardList} = this.state;

      const firstCard = cardList.splice(0, 1)[0];
      cardList.push(firstCard);

      this.setState({cardList: cardList});
    }, 3000);
  };

  componentWillUnmount() {
    window.clearInterval(this.frameId);
  }

  render() {
    const {cardList} = this.state;
    const cardListItem = cardList.map((card, index) => {
      let level;

      switch (index) {
        case 0:
          level = 'five';
          break;
        case 1:
          level = 'four';
          break;
        case 2:
          level = 'three';
          break;
        case 3:
          level = 'two';
          break;
        case 4:
          level = 'one';
          break;
        case 5:
          level = 'none';
          break;
        default:
          break;
      }
      if (index < 6) {
        return <TipCard key={card} background={card} level={level}/>
      } else return null;
    });

    return (
      <div className={cx('TipCardList')}>
        {cardListItem}
      </div>
    );
  }
}

export default TipCardList;


// WEBPACK FOOTER //
// ./src/app/intro/components/TipCardList/TipCardList.js